<template>
    <Teleport v-if="!withoutBackdrop" to="body">
        <LinceModal
            :title="title"
            :description="description"
            :isAnimation="isAnimation"
            :mode="modalMode"
            :styleModal="modalStyle"
            :styleBackdrop="styleBackdrop"
            :class="{ isAlignCenter }"
            @close="close"
            @scrollModal="onScrollModal"
        >
            <template v-slot:modalBody>
                <slot name="modalBody"></slot>
            </template>

            <template v-slot:actionButtons>
                <slot name="actionButtons"></slot>
            </template>
        </LinceModal>
    </Teleport>

    <LinceModal
        v-else
        :title="title"
        :description="description"
        :isAnimation="isAnimation"
        :mode="modalMode"
        :styleModal="modalStyle"
        :styleBackdrop="styleBackdrop"
        :class="{ isAlignCenter }"
        @close="close"
        @scrollModal="onScrollModal"
    >
        <template v-slot:modalBody>
            <slot name="modalBody"></slot>
        </template>

        <template v-slot:actionButtons>
            <slot name="actionButtons"></slot>
        </template>
    </LinceModal>
</template>

<script>
import Teleport from "vue2-teleport";

export default {
    name: "BaseModal",
    components: { Teleport },
    props: {
        isAnimation: Boolean,
        title: String,
        description: String,
        withoutBackdrop: Boolean,
        // modalStyle: Object,
        modalWidth: {
            type: String,
            default: ''
        },
        modalMaxHeight: {
            type: String,
            default: ''
        },
        modalStyleList: {
            type: Object,
            default: () => ({})
        },
        mainModalStyle:{
            type: Object,
            default: () => ({})
        },
        isAlignCenter: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        modalStyle() {
            let modalStyle = {};

            if (this.modalWidth)
                modalStyle.width = this.modalWidth;
            if (this.modalMaxHeight)
                modalStyle['max-height'] = this.modalMaxHeight;

            return { ...modalStyle, ...this.modalStyleList };
            // return this.modalWidth ? {width: this.modalWidth} : {}
        },
        modalMode() {
            return this.withoutBackdrop ? "base" : "backdrop";
        },
        styleBackdrop() {
            return { ...this.mainModalStyle, "align-items": "flex-start" };
        }
    },
    methods: {
        close() {
            this.$emit("close");
        },
        onScrollModal() {
            this.$emit("scrollModal");
        },
    },
};
</script>
